import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsJekyllComponent } from './simple-icons-jekyll.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsJekyllComponent ],
    exports:      [ SimpleIconsJekyllComponent ],
    bootstrap:    []
})
export class SimpleIconsJekyllModule {}
